<template>

    <div class='section'>

        <section class='section' id='filters'>
            <div v-for="field in query_fields"
                class="field"
            >

                <b-tag v-if="field.query" size="is-large"
                    type="is-primary"
                    closable
                    @close="ResetQuery(field.name)"
                >
                    {{ field.query }}
                </b-tag>
            </div>

        </section>


        <!-- buefy table -->
        <b-table
            :per-page="perPage"
            :current-page.sync="page"
            :loading="loading"
            
            :focusable=false
            :striped=true

            :data="data"

            :paginated="isPaginated"
            backend-pagination
            :total="total"

            @page-change="onPageChange"

            backend-sorting
            :default-sort-direction="defaultSortOrder"
            :default-sort="[sortField, sortOrder]"
            @sort="onSort"
        >
            <template slot-scope="props">

                <b-table-column field="name" label="Name" sortable>
                    <router-link :to="{ name: 'share', params: {uuid: props.row.uuid} }">
                        {{ props.row.title }}
                        <b-icon
                            icon="open-in-new"
                            size="is-small">
                        </b-icon>
                    </router-link>
                </b-table-column>

                <!--
                    disabled as only displays projrect id currently
                    
                    <b-table-column field="project" label="Project" sortable>
                        {{ props.row.project }}
                    </b-table-column>
                -->

                <b-table-column field="user" label="User" sortable>
                    <a @click="UpdateQuery('user', props.row.user)">{{ props.row.user }} </a>
                    <b-icon
                        icon="filter-outline"
                        size="is-small">
                    </b-icon>
                </b-table-column>

                <b-table-column field="date_created" label="Date Created" sortable>
                    {{ props.row.date_created | relative_datetime }}
                </b-table-column>

                <b-table-column>
                    <router-link class="button is-primary" :to="{ name: 'share-review', params: {'id': props.row.id} }">notes</router-link>
                </b-table-column>
                
            </template>
        </b-table>
    </div>

</template>

<script>
    import axios from 'axios'
    import { date_filters } from '../mixins/Filters'
    import { GetAxiosAuthConfig } from '../mixins/axiosAuth'

    export default {
        mixins: [date_filters, GetAxiosAuthConfig],
        data () {
            return {
                data: [],
                loading: false,

                perPage: 18, // 18 fits 24" monitor well
                total: 0,
                sortField: 'date_created',
                sortOrder: 'desc',
                defaultSortOrder: 'desc',
                page: 1,

                // set initially from router
                query_fields: [
                    {
                        name: 'user',
                        query: this.$route.query.user,
                    }
                ],
            }
        },
        computed: {
            isPaginated: function () {               
                // check if there are enough results that pagination buttons are needed
                return this.total > this.perPage
            }
        },
        methods: {
            loadAsyncData() {
                // create page offset
                let offset = this.perPage * (this.page-1)
                let sort = '';

                // create sort
                if (this.sortOrder == 'asc') {
                    sort = this.sortField
                }
                else {
                    sort = "-" + this.sortField
                }
                // create rest url based on page
                let resturl = window.location.origin + '/api/reviewableshares/?format=json&limit=' + this.perPage + '&offset=' + offset + '&ordering=' + sort

                // apply queries
                this.query_fields.forEach(function(field) {
                    if (field.query) {
                        resturl += '&' + field.name + '=' + field.query
                    }
                })
                
                if (process.env.NODE_ENV == 'development') {
                    console.info("reviewableshares: resturl", resturl)
                }

                this.loading = true

                axios.get(resturl, axios_auth_config)
                    .then(response => {
                     
                        // empty data
                        this.data = []
                        this.total = response.data.count
                        this.data = response.data.results
                        this.loading = false
                    })
                    .catch(error => console.log(error))
            },
            onPageChange(page) {
                this.page = page
                this.loadAsyncData()
            },
            onSort(field, order) {
                this.sortField = field
                this.sortOrder = order
                this.loadAsyncData()
            },
            UpdateQuery(field, value) {
                // change the router query, and change the data

                // append router query
                this.$router.push({
                    query: {
                        ...this.$route.query,
                        [field]: value
                    }
                })

                // get which query key was changed
                this.query_fields.forEach(function(query_field) {
                    
                    // update the queryfield with the value
                    if (query_field.name == field) {
                        query_field.query = value
                    }
                })

                this.loadAsyncData()
            },
            ResetQuery(query_key) {
                // change the router query, and change the data

                // append router query
                this.$router.replace({
                    query: {
                        ...this.$route.query,
                        [query_key]: null
                    }
                })


                // get which query key was changed
                this.query_fields.forEach(function(query_field) {
                    
                    if (query_field.name == query_key) {
                        // reset to null
                        query_field.query = null
                    }
                })

                // reload data
                this.loadAsyncData()
            },
        },
        filters: {
            // Filter to truncate string, accepts a length parameter
            truncate(value, length) {
                return value.length > length
                    ? value.substr(0, length) + '...'
                    : value
            }
        },
        mounted() {
            this.loadAsyncData()
        }
    }

        
    
</script>

<style scoped lang="scss">
    // this should inherit from App.vue but I dont know how
    $den_offwhite: #dddbd4;

    #filters {
        padding: 1rem;
        bottom: 1rem;
        left: 1rem;
        position: fixed;
    }
</style>